<!-- BANNER -->
<div class="mobile-header">
  <a class="back-btn text-white" [routerLink]="['/']">
    <i class="material-icons">arrow_back_ios</i>
  </a>
  <h5 class="title">{{ 'faq.page.title' | translate }}</h5>
</div>

<div class="container">
  <!--FAQs-->
  <div class="row faq-container">
    <div class="col-12">
      <fgbcl-faq-section></fgbcl-faq-section>
    </div>
  </div>
</div>
